module.exports = __webpack_public_path__ + "assets/media/dolmen-night.aa6656a1.ogg";